import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { FormField, FIELD_TYPES } from '@techchange/components';
import { Loading, SCOPES } from '@techchange/components';
import { messages } from '../../../../i18n';
import { ENUMS_VIDEO, useLibraryVideoContext } from '@techchange/video';

import { videoDataShape } from '../../utils/propTypes';

const propTypes = {

	/**
	 * The video resource's current form data.
	 */
	formData: PropTypes.shape({

		/**
		 * The current scope.
		 */
		scope: PropTypes.oneOf([
			SCOPES.SESSION,
			SCOPES.ORGANIZATION,
		]).isRequired,

		/**
		 * The current scope ID.
		 */
		scope_id: PropTypes.string.isRequired,

		/**
		 * The content data.
		 */
		data: PropTypes.shape(videoDataShape),


	}),

	/**
	 * The video field's input validation.
	 */
	videoInputValidation: PropTypes.shape({

		/**
		 * True if the current input is invalid.
		 */
		invalid: PropTypes.bool,

		/**
		 * The error message, if any.
		 */
		error: PropTypes.string,

	}),

	/**
	 * The callback function to change the form field.
	 */
	onChange: PropTypes.func.isRequired,

};

/**
 * Form field for the "data.video_id" field in a video resource.
 * Only used when the "data.provider" is "Library".
 *
 * @param {Object} props  The component props.
 *
 * @returns {Object}  The component to render.
 */
const LibraryVideoField = (props) => {

	const { formData, videoInputValidation, onChange } = props;

	const intl = useIntl();

	const { video, videoError, isLoading } = useLibraryVideoContext();

	if (isLoading) {
		return <Loading isLoading />;
	}

	return (
		<FormField
			type={FIELD_TYPES.VIDEO}
			className="mb-4"
			name="video_id"
			value={video}
			label={intl.formatMessage(messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_VIDEO_ID)}
			placeholder={intl.formatMessage(messages.TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_VIDEO_ID)}
			videoProvider={ENUMS_VIDEO.PROVIDER.MUX}
			scope={formData.scope}
			scopeId={formData.scope_id}
			isInvalid={videoInputValidation?.invalid}
			error={videoInputValidation?.error || videoError}
			aspectRatio={formData.data.aspectRatio}
			isAdmin
			isLabelHidden
			isEditing
			onChange={onChange} />
	);

};

LibraryVideoField.propTypes = propTypes;

export default LibraryVideoField;
